import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { LegalProvider } from "@/context/LegalContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Presentation from "@/components/site/Presentation";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CookieConsent from "@/components/site/CookieConsent";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <LegalProvider>
        <div className="App bg-white text-[#1F2937] antialiased selection:bg-[#B87333] selection:text-white">
          <Toaster position="top-right" richColors />
          <Header />
          <main>
            <Hero />
            <Presentation />
            <About />
            <Services />
            <Portfolio />
            <Contact />
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </LegalProvider>
    </LanguageProvider>
  );
}

export default App;
